export const RegentsPanelColumns = {
  REVIEW: {
    humanName: 'Review',
  },
  EXAM_NAME: {
    humanName: 'Exam Name',
    parentPath: 'regentsDetails.byExam',
    childPath: 'exam',
  },
  ATTEMPTS: {
    humanName: 'Attempts',
    parentPath: 'regentsDetails.byExam',
    childPath: 'attempts',
  },
  MAX_SCORE: {
    humanName: 'Max Score',
    parentPath: 'regentsDetails.byExam',
    childPath: 'maxScore.string',
  },
  RECOMMENDATION: {
    humanName: 'Recommendation',
    parentPath: 'regentsDetails.byExam',
    childPath: 'recommendation',
  },
  NEXT_SCHEDULED: {
    humanName: 'Next Scheduled',
    parentPath: 'nextScheduledRegents',
    childPath: 'adminDate',
  },
  SCHEDULED_IN_STARS: {
    humanName: 'Scheduled in STARS',
    parentPath: 'regentsDetails.byExam',
    childPath: 'schedInStars',
  },
  SUPPORTING_COURSES: {
    humanName: 'Supporting Courses',
  },
  ADDITIONAL_SUPPORTS: {
    humanName: 'Additional Supports',
  },
};
